import React from 'react'
import { ConnectDragSource } from 'react-dnd'
import { Icon, IconChoices } from '../../../../common/Icon'
import { Card } from '../../../../common/Card'
import { CardFooter } from '../../../../common/Card/CardFooter'
import { theme } from '../../../../../theme/theme'
import { cn } from '../../../../../helpers/utils'
import { Dropdown, Option } from '../../../../common/Dropdown'
import { Button } from '../../../../common/Button'

interface BinderListCardItemProps {
  isAdminView: boolean
  openItem: () => void
  documentTitle: string
  documentSubtitle: string
  isFolder: boolean
  documentIcon: IconChoices
  dropdownOptions: Option[]
  documentUrl?: string
  isDragging?: boolean
  drag?: ConnectDragSource
  isOver?: boolean
}

export const BinderListCardItem = ({
  isAdminView,
  openItem,
  documentTitle,
  documentSubtitle,
  isFolder,
  documentIcon,
  dropdownOptions,
  documentUrl,
  isDragging = false,
  drag,
  isOver,
}: BinderListCardItemProps): JSX.Element => {
  return (
    <Card
      ref={isAdminView ? drag || null : null}
      className={`flex h-[200px] w-full items-center ${
        isAdminView ? 'cursor-move' : 'cursor-pointer'
      } ${isOver ? 'bg-neutral-90' : 'bg-white'} ${isDragging ? 'opacity-50' : ''}`}
      onClick={openItem}
    >
      {{
        body: (
          <div
            className={cn(
              'flex h-full w-full items-center justify-center rounded-t-lg',
              !documentUrl && 'bg-neutral-94'
            )}
            style={
              documentUrl
                ? {
                    backgroundImage: `url(${documentUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }
                : undefined
            }
          >
            {!documentUrl && <Icon size={64} icon={documentIcon} />}
          </div>
        ),
        footer: (
          <CardFooter className="flex h-4/6 w-full items-start p-4">
            <div className="flex w-5/6 min-w-0 flex-col items-start overflow-hidden">
              <p
                className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
                style={theme.textVariants.base}
              >
                {documentTitle}
              </p>
              <p style={theme.textVariants.caption} className="text-neutral-50">
                {documentSubtitle}
              </p>
            </div>
            {isAdminView ? (
              <Dropdown options={dropdownOptions}>
                <Button
                  icon={IconChoices.KEBAB_MENU}
                  className="h-10 w-10 border-none bg-transparent hover:bg-neutral-85"
                  disableTabIndex
                />
              </Dropdown>
            ) : (
              !isFolder && (
                <Dropdown options={dropdownOptions}>
                  <Button
                    icon={IconChoices.KEBAB_MENU}
                    className="h-10 w-10 border-none bg-transparent hover:bg-neutral-85"
                    disableTabIndex
                  />
                </Dropdown>
              )
            )}
          </CardFooter>
        ),
      }}
    </Card>
  )
}
